module.exports = __webpack_public_path__ + "static/media/arrows-alt-v.3845f52e.svg";